export var CustomizeReportRowCountError;
(function (CustomizeReportRowCountError) {
})(CustomizeReportRowCountError || (CustomizeReportRowCountError = {}));
var CustomizeReportRowCountRequest = /** @class */ (function () {
    function CustomizeReportRowCountRequest(id, custom, reportSettings, query) {
        if (query === void 0) { query = {}; }
        this.knownErrorCodes = Object.values(CustomizeReportRowCountError);
        this.method = custom ? 'put' : 'post';
        this.path = "".concat(custom ? 'my/customized-' : '', "reports/").concat(encodeURIComponent(id), "/rows/count?").concat(String(new URLSearchParams(query)));
        this.body = JSON.stringify(reportSettings.columnFilters);
    }
    return CustomizeReportRowCountRequest;
}());
export { CustomizeReportRowCountRequest };
